<template>
  <div>
    <div v-dusk="'page-header'" class="page-header" style="border-bottom: 0">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <h2>Register</h2>
          </div>
        </div>
      </div>
    </div>
    <br />

    <section v-if="currentStep === 1">
      <registration-step1
        :customer-segments="customerSegments"
      ></registration-step1>
    </section>

    <section v-if="currentStep === 2">
      <registration-step2></registration-step2>
    </section>

    <section v-if="currentStep === 3">
      <registration-step3 :form-type="currentFormType"></registration-step3>
    </section>

    <section v-if="currentStep === 4">
      <registration-step4></registration-step4>
    </section>

    <section v-if="currentStep === 5">
      <registration-step5></registration-step5>
    </section>
  </div>
</template>

<script>
// eslint-disable-next-line
import Scroll from "./forms/elements/Scroll";
import RegistrationStep1 from "./RegistrationStep1.vue";
import RegistrationStep2 from "./RegistrationStep2.vue";
import RegistrationStep3 from "./RegistrationStep3.vue";
import RegistrationStep4 from "./RegistrationStep4.vue";
import RegistrationStep5 from "./RegistrationStep5.vue";

export default {
  components: {
    Scroll, // eslint-disable-line vue/no-unused-components
    RegistrationStep1,
    RegistrationStep2,
    RegistrationStep3,
    RegistrationStep4,
    RegistrationStep5,
  },
  props: {
    varReseller: {
      type: String,
      default: "",
    },
    customerSegments: {
      type: Array,
      required: true,
    },
    validParameters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentStep() {
      return this.$store.state.registration.step;
    },
    currentFormType() {
      return this.$store.state.registration.type;
    },
  },
  created() {
    if (this.varReseller) {
      this.$store.dispatch("setVarReseller", this.varReseller);
    }
    this.$store.dispatch("setValidParameters", this.validParameters);
  },
};
</script>
